import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/style.css';
import './styles/images.css';
import './styles/no-touch.min.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

//SET NODE_OPTIONS=--openssl-legacy-provider
//SET NODE_OPTIONS=--openssl-legacy-provider
